import { BehaviorSubject, Observable } from 'rxjs';
import { TblSubMenu } from '../shared/models/SubMenu';
import { TblMenu } from '../shared/models/Menu';
import { LocalStorageService } from './localStorageService';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MenuService {
    

    private userMenus: TblMenu[] = [];
    private menusLoaded = new BehaviorSubject<boolean>(false);
    menusLoaded$ = this.menusLoaded.asObservable();

    constructor(private localStorage: LocalStorageService,private http: HttpClient) { }

    setMenus(menus: TblMenu[]) {
        this.userMenus = menus;
        this.localStorage.set('menus', JSON.stringify(menus));
        this.menusLoaded.next(true); // notify guard
    }

    loadMenus() {
        const saved = this.localStorage.get('menus');
        if (saved) {
            this.userMenus = JSON.parse(saved);
            this.menusLoaded.next(true);
        }
    }

    getAllSubMenus(): TblSubMenu[] {
        return this.userMenus.flatMap(menu => menu.submenu);
    }
}
